import * as React from "react";

import GenModal from "../Gen/Modal/component";
import AdminAssessmentReusableObjects from "../Admin/Assessment/ReusableObjects/component";

import {
  newAddTextNodesBeforeNodeChange,
  newAddTextAndNodesToNodeChange,
} from "../../helpers/Doc/changes";
import { RLO_MODAL, LIST_RLO_MODAL } from "../../helpers/Doc/menu";

interface ListRLOModalProps {
  editingContextExtra: EditingContextExtra;
  editingContext: EditingContextInEditor;
  permissions: AqPermissions;
  currentUser: {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    [key: string]: any;
  };
};

const ListRLOModal = (props: ListRLOModalProps) => {
  const {
    editingContextExtra,
    editingContext,
    permissions,
    currentUser
  } = props;

  const [rloModalOpen, setRloModalOpen] = React.useState(true);
  const [rlo, setRlo] = React.useState(null)
  const [addModalOpen, setAddModalOpen] = React.useState(false)

  const closeRloModal = () => {
    setRloModalOpen(false)
    editingContext.closeCurrentMenu()
  }

  const handleAddModalOpen = (rlo) => {
    setRlo(rlo)
    setAddModalOpen(true)
  }

  const closeAddModal = () => {
    setRlo(null)
    setAddModalOpen(false)
  }

  const addModalContinue = () => {
    const currentMenu = editingContextExtra.currentMenu;
    if (currentMenu?.menu !== LIST_RLO_MODAL) { return }

    // The rlo object now has full variant data loaded from AdminAssessmentReusableObjects
    if (!rlo.review_variant || !rlo.review_variant.change_data) {
      console.error('Review variant or change_data not found for reusable object:', rlo);
      alert('Error: Could not load reusable object variant data. Please try again.');
      return;
    }

    const node = {
      ...rlo.review_variant.change_data,
      roDocumentCount: (rlo.data?.roDocumentCount || 1) + 1,
    }

    if (currentMenu.siblingUid) {
      editingContext.addChange(newAddTextNodesBeforeNodeChange(currentMenu.siblingUid, null, [node]))
    } else {
      editingContext.addChange(newAddTextAndNodesToNodeChange(currentMenu.uid, currentMenu.contentKey, null, [node]));
    }
    editingContextExtra.setCurrentRO(node)
    editingContext.setCurrentMenu(RLO_MODAL, {data: rlo, menu: RLO_MODAL})
    closeAddModal()
  }

  return (
    <>
    <GenModal open={rloModalOpen} >
      <div className="gen-modal-panel gen-modal-panel-large gen-modal-media-menu" style={{marginTop: 90 + 'px', width: 80 + '%', marginLeft: 100 + 'px'}}>
        <div style={{textAlign: "end"}}>
          <button onClick={closeRloModal}>X</button>
        </div>
        <AdminAssessmentReusableObjects
          currentUser={currentUser}
          editorContext={{
            isEditorMode: true,
            permissions: permissions,
            onAddClick: handleAddModalOpen
          }}
        />
      </div>
    </GenModal>

    <GenModal open={addModalOpen} >
      <div className="gen-modal-panel gen-modal-media-menu" style={{marginTop: 90 + 'px'}}>
        <div style={{textAlign: "center"}}>
          <div style={{marginBottom: "20px"}}>Click <b>Continue</b> to insert this Reusable Content to your document or <b>Cancel</b> to discard.</div>
          <button onClick={addModalContinue} style={{marginRight: "20px"}} >Continue</button>
          <button onClick={closeAddModal}>Cancel</button>
        </div>
      </div>
    </GenModal>
    </>
  );
}

export default ListRLOModal;
